/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://en4uhwv5fbgc3g6y7prfe4o5qu.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-eml5ifkwdjgrbgbf4di2ycdjei",
    "aws_cognito_identity_pool_id": "us-east-1:f83ca54b-3ce3-4e2e-802c-1396cb7aa9bf",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_dmtWbCDre",
    "aws_user_pools_web_client_id": "3pobsidfd35jmrr394u8rq23ov",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "businessstorages3155339-dev",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
